/**
 * Extract a filename from a Content-Disposition header value.
 * Returns the provided defaultFilename when the header is absent or unparseable.
 */
export function extractContentDispositionFilename(cd: string | null, defaultFilename: string): string {
  if (cd) {
    const matches = cd.match(/filename[*]?=['"]?([^'"]+)['"]?/i);
    if (matches && matches[1]) return matches[1].replace(/['"]/g, '');
  }
  return defaultFilename;
}
